<!-- 
  这个组件是封装了表格和分页组件在内，只需要提供columns（Table组件）、query函数（接口查询）和queryParams（接口查询参数）即可

  e.g.
  
  <combo-table :query="queryAPI" :columns="columns" :queryParams="queryParams"></combo-table>

  queryAPI(params){
    return API.omsAPI[this.env].cleaner.cleanStepItemList(params,this.token)
  }
 -->
<template>
  <div>
    <Table stripe :loading="loading" :columns="columns" :data="data"></Table>
    <div style="float: left;margin: 10px;overflow: hidden">
      <Page show-sizer placement="top" :total="count" :current="page" @on-page-size-change="changePageSize"
        @on-change="changePage"></Page>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    query: {
      type: Function,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    queryParams: {
      type: Object,
      required: false
    }
  },
  created() {
  },
  mounted() {
    this.load()
  },
  data(){
    return {
      data:[],
      page:1,
      count:0,
      pageSize:10,
      loading:false,
      reqParams: {}
    }
  },
  methods:{
    async load(){
      const {page,pageSize,reqParams} = this
      let params = {page,pageSize}

      if(reqParams){
        params = Object.assign(params,reqParams)
      }

      const {content,totalCount} = (await this.query(params)).data
      
      this.data = content
      this.count = totalCount
    },
    reload(){
      this.page = 1

      this.reqParams = Object.assign({}, this.queryParams)
      
      this.load()

    },
    changePageSize(pageSize){
      this.pageSize = pageSize
      this.load()
    },

    changePage(pageIndex){
      this.page = pageIndex
      this.load()
    }
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/combo-table.vue